// The API target is embedded at build time. Other deployments can override it
// with REACT_APP_API_URL without changing the shared production default.
const configuredApiUrl = process.env.REACT_APP_API_URL?.trim();
const defaultApiUrl =
	process.env.REACT_APP_ENV === "production"
		? "https://api.vlfsportsperformance.it"
		: "https://localhost:7209";

const apiUrl = (configuredApiUrl || defaultApiUrl).replace(/\/+$/, "");

export default apiUrl;
